/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayoutTierPlace
 */
export interface PayoutTierPlace {
    /**
     * Finishing position (1 = first place)
     * @type {number}
     * @memberof PayoutTierPlace
     */
    place: number;
    /**
     * Percentage of prize pool awarded (e.g. 50 means 50%). All places in a tier must sum to 100.
     * @type {number}
     * @memberof PayoutTierPlace
     */
    percent: number;
    /**
     * Optional display label such as Champion or Runner Up
     * @type {string}
     * @memberof PayoutTierPlace
     */
    label?: string;
}

/**
 * Check if a given object implements the PayoutTierPlace interface.
 */
export function instanceOfPayoutTierPlace(value: object): value is PayoutTierPlace {
    if (!('place' in value) || value['place'] === undefined) return false;
    if (!('percent' in value) || value['percent'] === undefined) return false;
    return true;
}

export function PayoutTierPlaceFromJSON(json: any): PayoutTierPlace {
    return PayoutTierPlaceFromJSONTyped(json, false);
}

export function PayoutTierPlaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayoutTierPlace {
    if (json == null) {
        return json;
    }
    return {
        
        'place': json['place'],
        'percent': json['percent'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function PayoutTierPlaceToJSON(json: any): PayoutTierPlace {
    return PayoutTierPlaceToJSONTyped(json, false);
}

export function PayoutTierPlaceToJSONTyped(value?: PayoutTierPlace | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'place': value['place'],
        'percent': value['percent'],
        'label': value['label'],
    };
}

